export default function parseYupErrors(err) {
    const inner = err.inner;
    const errors = {};
    for( const e of inner) {
        errors[e.path] = (e.message.charAt(0).toUpperCase() + e.message.slice(1))
            .replace('_', ' ');
    }
    return errors;
}